import { IconButton, Typography } from '@mui/material';
import styled from 'styled-components';

interface ContentProps {
  $dense: boolean,
  $titled: boolean,
}

const Content = styled.div<ContentProps>`
  margin-top: ${({ theme, $dense, $titled }) => (($dense && !$titled) ? 0 : theme.spacing(2))};
  margin-bottom: ${({ theme, $dense }) => ($dense ? 0 : theme.spacing(2))};
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Title = styled(Typography)`
  && {
    color: ${({ theme }) => theme.palette.backdrop.contrastText};
  }
`;

const Caption = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

const BackButton = styled(IconButton)`
  && {
    color: ${({ theme }) => theme.palette.backdrop.contrastText};
    margin-right: ${({ theme }) => theme.spacing(2)};
  }
`;

export { Content, Title, Caption, TitleContainer, BackButton };
